import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAeP0nh5WcvU8FUSrJVr5TogACAwXWKCNw",
  authDomain: "jatear-tintas-46411.firebaseapp.com",
  projectId: "jatear-tintas-46411",
  storageBucket: "jatear-tintas-46411.firebasestorage.app",
  messagingSenderId: "1019421138374",
  appId: "1:1019421138374:web:df4e88f5be5ae49e8ea6c7"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;